import React from 'react';

import Framework from '@beardeddevops/react.framework';
import {Collections} from 'components';
import UserRoles from 'constants/UserRoles';

const breadcrumbsStatic = [
	{
		name: 'Dispatch',
		url: '/dispatch',
		icon: 'dashboard',
	},
];

export default class DailyEta extends Framework.Components.View {
	render() {
		const isEngineersRoute = (this.props.location?.pathname || '').includes('/engineers/');
		const breadcrumbs = (isEngineersRoute
			? [{name: 'Engineers', url: '/engineers', icon: 'dashboard'}]
			: breadcrumbsStatic
		).concat([
			{
				name: 'Daily ETA',
				url: isEngineersRoute ? '/engineers/daily_eta' : '/dispatch/daily_eta',
				icon: 'clock-o',
			},
		]);

		const feSelfView =
			isEngineersRoute ||
			(Array.isArray(this.props.roles) &&
				this.props.roles.includes(UserRoles.FieldEngineer) &&
				!this.props.roles.some((r) =>
					[UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(r)
				));

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Collections.DailyEtaBoard
					history={this.props.history}
					location={this.props.location}
					regions={this.props.regions}
					roles={this.props.roles}
					userPkey={this.props.user?.pkey || this.props.user}
					feSelfView={feSelfView}
				/>
			</div>
		);
	}
}
